import { Button } from '@synoptic/ui-kit/button/button.tsx';
import { FC } from 'react';
import { TournamentPostCardFragmentFragment } from '@/__generated__/graphql.ts';
import { TournamentPostCard } from '@/components/tournament-post-card/tournament-post-card.tsx';
import { Link } from '@/routes-utils/navigation.tsx';
import { paths } from '@/routes-utils/paths.ts';
import {
  latestSubmissions,
  latestSubmissionsHeader,
} from '@/routes/_app.p.tournaments_.$id._index/page.css.ts';
import {
  sectionLabel,
  tournamentSection,
} from '@/routes/_app.p.tournaments_.$id/page.css.ts';

export const LatestSubmissions: FC<{
  tournamentId: string;
  submissions: TournamentPostCardFragmentFragment[];
}> = ({ tournamentId, submissions }) => {
  return (
    <div className={tournamentSection}>
      <div className={latestSubmissionsHeader}>
        <h3 className={sectionLabel}>Latest Submissions</h3>
        <Button size="small" variant="ghost">
          <Link to={paths.makeSubmissions(tournamentId)}>
            See all submissions
          </Link>
        </Button>
      </div>

      <div className={latestSubmissions}>
        {submissions.slice(0, 3).map((submission) => (
          <TournamentPostCard
            key={submission.id}
            post={submission}
            linkToPost
          />
        ))}
      </div>
    </div>
  );
};
